import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useChatgelesenMutation, useGetAuftraegeWithMessagesMutation } from '../../api/AuftragMessagesAPI';
import AuftragMessageComponent from '../../component/chat/AuftragMessageComponent/AuftragMessageComponent';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';
import ScrollToTopBadge from '../../component/ScrollToTop';
import { IAuftragMessageListe } from '../../types/Types';
import { formatToEuroDateTime } from '../../util/DateUtils';
import LandingpageHeader from '../header/LandingpageHeader';

/**
 * @author noone
 */
type ThisProps = {
  //originalListe: IAuftragAgAnsicht[];
  //statusChanged: () => void;
}

export default function ChatListe(props: ThisProps) {

  const { t } = useTranslation();
  const navigate = useNavigate();

  const [getChatListeAPI] = useGetAuftraegeWithMessagesMutation();
  const [chatGelesenAPI] = useChatgelesenMutation();

  const [anzeige, setAnzeige] = useState<String>("");
  const [chatDetail, setChatDetail] = useState<IAuftragMessageListe>();
  const [liste, setListe] = useState<IAuftragMessageListe[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleAlleGelesen = ( e : React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    chatGelesenAPI(chatDetail!!.uid_auftrag).unwrap()
      .then(() => {
        setListe((prevListe) => prevListe.map((chat) => {
          if (chat.uid_auftrag === chatDetail!!.uid_auftrag) {
            return { ...chat, anzahl_nicht_gelesen: 0 };
          }
          return chat;
        }));
      })
      .catch((error) => console.log(error));
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    setIsLoading(true);
    getChatListeAPI().unwrap()
      .then((data) => {
        const filtered = data.filter((e) => e.anzahl_gesamt > 0);
        const sorted = [...filtered].sort((a, b) => {
          const ta = a.lastMessageDateTime ? new Date(a.lastMessageDateTime).getTime() : 0;
          const tb = b.lastMessageDateTime ? new Date(b.lastMessageDateTime).getTime() : 0;
          return tb - ta; // neueste zuerst
        });
        setListe(sorted);
      })
      .catch((error) => console.error("Fehler beim Laden der Chat Liste:", error))
      .finally(() => setIsLoading(false))
      ;
  }, []);

  return (
    <>
      {anzeige === "" &&
        <div>

          <LandingpageHeader />

          <div className="container">

            <button
              onClick={() => {
                navigate("/", {
                  relative: "path"
                });
              }}

              style={{ marginBottom: "20px" }}
              className=' btn btn-outline-primary'
            ><i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
            </button>

            <h3>Chat Liste</h3>

            {liste.map((chat) =>
              <>
                <div key={chat.uid_auftrag} className="card shadow-sm mb-4">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start">

                      <div>
                        <h5 className="card-title mb-1">Kunde: {chat.auftragDto.vorname_endkunde} {chat.auftragDto.name_endkunde} / AG: {chat.auftragDto.auftraggeber.name}</h5>
                        {chat.anzahl_nicht_gelesen > 0 &&
                          <span className="badge bg-success rounded-pill" style={{ color: "white" }}>
                            Neue Nachrichten&nbsp;•&nbsp;{chat.anzahl_nicht_gelesen}
                          </span>
                        }
                      </div>

                      <div className="d-flex gap-2">
                        <a href="#" className="btn btn-primary" onClick={() => { setAnzeige("detail"); setChatDetail(chat); }}><i className="bi bi-chat"></i> zum Chat</a>
                        <a href="#" className="btn btn-outline-secondary" onClick={() => navigate("/eigeneauftraege/detail/" + chat.auftragDto.uid)}><i className="bi bi-file-earmark-post"></i> zum Auftrag</a>
                      </div>
                    </div>

                    <hr className="my-4" />

                    <p className="mb-1"><strong>Gesamt:</strong> {chat.anzahl_gesamt}</p>
                    <p className="mb-0"><strong>Letzte Nachricht:</strong> {formatToEuroDateTime(chat.lastMessageDateTime)}</p>
                  </div>
                </div>

              </>
            )}

            <ScrollToTopBadge />

          </div>

          <LoadingModal show={isLoading} />

        </div >
      }
      {anzeige === "detail" &&
        <>
          <div>

            <LandingpageHeader />

            <div className="container">

              <button
                onClick={() => {
                  setAnzeige("");
                }}

                style={{ marginBottom: "20px" }}
                className=' btn btn-outline-primary'
              ><i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
              </button>

              <button onClick={handleAlleGelesen}
                style={{ marginBottom: "20px" }}
                className=' btn btn-outline-success'
              ><i className="bi bi-eye"></i> alle gelesen
              </button>

              {chatDetail &&
                <AuftragMessageComponent auftragUid={chatDetail?.uid_auftrag} />
              }
              <ScrollToTopBadge />

            </div>

          </div >
        </>
      }
    </>
  );

}
